<app-page-wrapper>
    <app-onboarding-banner></app-onboarding-banner>
    <h1>Create your account</h1>
    <form>
        <div class="row">
            <div class="col-3">
                <label for="email">Email Address</label>
                <input class="form-control" name="email" type="email" required
                    [(ngModel)]="newAccount.Email" placeholder="Enter email address">
            </div>
        </div>
        <div class="row">
            <div class="col-3">
                <label for="name">Full Name</label>
                <input class="form-control" name="name" required
                    [(ngModel)]="newAccount.Name" placeholder="Enter your name">
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <label for="password">Password</label>
            </div>
            <div class="col-3">
                <input class="form-control" name="password" type="password" required 
                    [(ngModel)]="newAccount.Password" placeholder="Enter your password" (change)="validatePassword()">
            </div>
            <div class="col-9 align-with-input">
                <i>
                    <span [ngClass]="passwordErrors.length ? 'error-message' : ''">Minimum of 8 characters</span> 
                    with at least one of each: 
                    <span [ngClass]="passwordErrors.upper ? 'error-message' : ''">uppercase</span>, 
                    <span [ngClass]="passwordErrors.lower ? 'error-message' : ''">lowercase</span>, 
                    <span [ngClass]="passwordErrors.other ? 'error-message' : ''">number or symbol</span>
                </i>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <label for="confirm-password">Confirm Password</label>
            </div>
            <div class="col-3">
                <input class="form-control" name="confirm-password" type="password" required
                [(ngModel)]="confirmPassword" placeholder="Confirm your password" (change)="validatePassword()">
            </div>
            <div class="col-9 align-with-input">
                <div class="error-message" *ngIf="confirmPasswordMismatch">The password confirmation did not match</div>
            </div>
        </div>
        <button class="btn btn-primary save-button" (click)="createAccount()">Save</button>
    </form>
</app-page-wrapper>